import React from 'react';
import { observer } from 'mobx-react';
import { AntSelect } from 'controls/react/ant/ant-select/antSelect';
import { AntSelectPropsGeneric } from 'controls/react/ant/ant-select/types';
import { useRemoteListForSelect } from 'framework/api';
import { translator } from 'core/localization';
import { Dashboard, getDashboardsLite } from 'areas/dashboards/api';
import { HomeTabType } from 'areas/summary/types';

const i = translator({
	'Ceeview home view': {
		no: 'Ceeview hjem skjerm',
	},
});

export type LandingPagesSelectorProps = AntSelectPropsGeneric<string[]> & {
	accountId?: string;
};

export const LandingPagesSelector = observer((props: LandingPagesSelectorProps) => {
	const [options, setOptions] = React.useState([]);
	const { accountId, ...rest } = props;
	const { options: remoteOptions, ...remoteData } = useRemoteListForSelect(getDashboardsLite(accountId, true), {
		sort: true,
		labelField: 'tag',
		valueField: 'id',
		converter: (dashboard: Dashboard) => ({
			...dashboard,
			tag: dashboard.accountId !== accountId ? `${dashboard.tag} (${dashboard.accountName})` : dashboard.tag,
		}),
	});

	React.useEffect(() => {
		setOptions([
			{
				label: i('Ceeview home view'),
				title: i('Ceeview home view'),
				order: 0,
				options: [{ label: i('Ceeview home view'), value: HomeTabType.HOME_VIEW }],
			},
			{
				label: i('Dashboards'),
				title: i('Dashboards'),
				order: 1,
				options: remoteOptions,
			},
		]);
	}, [remoteOptions]);
	return <AntSelect mode={'multiple'} {...remoteData} options={options} {...rest} />;
});
